import { useTranslation } from 'react-i18next';

const areas = [
  { name: 'Boise', icon: 'ri-map-pin-line', primary: true },
  { name: 'Meridian', icon: 'ri-map-pin-line', primary: false },
  { name: 'Nampa', icon: 'ri-map-pin-line', primary: false },
  { name: 'Caldwell', icon: 'ri-map-pin-line', primary: false },
  { name: 'Kuna', icon: 'ri-map-pin-line', primary: false },
  { name: 'Eagle', icon: 'ri-map-pin-line', primary: false },
  { name: 'Middleton', icon: 'ri-map-pin-line', primary: false },
  { name: 'Star', icon: 'ri-map-pin-line', primary: false },
];

export default function ServiceArea() {
  const { t } = useTranslation();

  return (
    <section className="py-16 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-[#0D0D0D] border border-white/5 rounded-2xl overflow-hidden">
          {/* Top image strip */}
          <div className="relative h-48 md:h-56 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Boise%20Idaho%20cityscape%20skyline%20aerial%20view%20urban%20landscape%20mountains%20background%20warm%20sunset%20golden%20hour%20dramatic%20sky%20beautiful%20city%20panoramic%20wide%20shot%20professional%20photography&width=1400&height=400&seq=sarea1&orientation=landscape"
              alt="Boise Idaho – Colombian food truck service area"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-[#0D0D0D]"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <div className="inline-flex items-center gap-2 bg-[#F57F25]/20 border border-[#F57F25]/40 text-[#F57F25] text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest mb-3">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-2-line text-xs"></i>
                  </div>
                  {t('location_area_badge')}
                </div>
                <h2 className="text-white font-black text-3xl md:text-4xl uppercase tracking-tight">
                  {t('location_area_title')}
                </h2>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="px-6 md:px-10 py-10">
            <p
              className="text-white/60 text-base leading-relaxed max-w-3xl mb-10"
              dangerouslySetInnerHTML={{ __html: t('location_area_text') }}
            />

            {/* Area chips */}
            <div className="flex flex-wrap gap-3 mb-10">
              {areas.map((area) => (
                <div
                  key={area.name}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${
                    area.primary
                      ? 'bg-[#F57F25]/15 border-[#F57F25]/30 text-[#F57F25]'
                      : 'bg-white/5 border-white/10 text-white/60'
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${area.icon} text-xs`}></i>
                  </div>
                  {area.name}
                </div>
              ))}
            </div>

            {/* SEO-rich local trust text */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 border-t border-white/5 pt-8">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#F57F25]/10 rounded-lg shrink-0 mt-0.5">
                  <i className="ri-truck-line text-[#F57F25] text-sm"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-1">{t('location_trust_1_title')}</p>
                  <p className="text-white/40 text-xs leading-relaxed">{t('location_trust_1_desc')}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#F57F25]/10 rounded-lg shrink-0 mt-0.5">
                  <i className="ri-restaurant-line text-[#F57F25] text-sm"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-1">{t('location_trust_2_title')}</p>
                  <p className="text-white/40 text-xs leading-relaxed">{t('location_trust_2_desc')}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#F57F25]/10 rounded-lg shrink-0 mt-0.5">
                  <i className="ri-heart-line text-[#F57F25] text-sm"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-1">{t('location_trust_3_title')}</p>
                  <p className="text-white/40 text-xs leading-relaxed">{t('location_trust_3_desc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
